var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [_vm._v(" Add an IP or Range ")]),
      _c(
        "gg-card-text",
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12"
                  }
                },
                [
                  _c(
                    "v-radio-group",
                    {
                      attrs: {
                        row: ""
                      },
                      model: {
                        value: _vm.model.radio,
                        callback: function callback($$v) {
                          _vm.$set(_vm.model, "radio", $$v)
                        },
                        expression: "model.radio"
                      }
                    },
                    _vm._l(_vm.radioItems, function(item, key) {
                      return _c("v-radio", {
                        key: key,
                        attrs: {
                          label: item.text,
                          value: item.value
                        }
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    md: "4",
                    lg: "3"
                  }
                },
                [
                  _c("gg-text-field", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: "ipValidator|required",
                        expression: "'ipValidator|required'"
                      }
                    ],
                    attrs: {
                      label: _vm.beginLabel,
                      name: "firstIp",
                      "data-vv-as": "IP Address or Domain",
                      "error-messages": _vm.errors.collect("firstIp"),
                      hint: _vm.beginHint
                    },
                    model: {
                      value: _vm.model.firstIp,
                      callback: function callback($$v) {
                        _vm.$set(_vm.model, "firstIp", $$v)
                      },
                      expression: "model.firstIp"
                    }
                  })
                ],
                1
              ),
              _vm.model.radio === "range"
                ? _c(
                    "v-col",
                    {
                      attrs: {
                        cols: "12",
                        md: "4",
                        lg: "3"
                      }
                    },
                    [
                      _c("gg-text-field", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "ipValidator|required",
                            expression: "'ipValidator|required'"
                          }
                        ],
                        attrs: {
                          label: _vm.endLabel,
                          name: "lastIp",
                          "data-vv-as": "IP Address",
                          "error-messages": _vm.errors.collect("lastIp"),
                          hint: _vm.endHint
                        },
                        model: {
                          value: _vm.model.lastIp,
                          callback: function callback($$v) {
                            _vm.$set(_vm.model, "lastIp", $$v)
                          },
                          expression: "model.lastIp"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "gg-btn",
            {
              attrs: {
                loading: _vm.pending
              },
              on: {
                click: _vm.addNewIp
              }
            },
            [_vm._v("Add")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }